// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","capa":"Card_capa__Q8xDR","icon":"Card_icon__uNzFc","icone":"Card_icone__Pm5lw"};